import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ChangeElementTypologyDialog,
  FormSubmitButtons,
  GridWrap,
  InfoWrapper,
  RHFSelect,
  RHFTagAutocomplete,
} from 'components';
import { tipologiaTraveOptions } from 'constants/selectOptions';
import { INFO } from 'pages/Inspections/config/info';
import { resetObjectSchedaIspezione } from 'utils/Inspections/L1/resetSchedaIspezione';
import useSchedaDifetti from 'utils/Inspections/L1/schedeDifetti';
import { isNullOrUndefinedOrEmptyString } from 'utils/utilities';

const TraviForm = ({
  traviFields,
  selected,
  setSelected,
  traviTable,
  selectedIdx,
}) => {
  const { getValues, setValue } = useFormContext({
    defaultValues: {
      traviTableValue: [],
      tipologiaTraveTableValue: '',
    },
  });

  const { populateSchedaDifetti } = useSchedaDifetti();

  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  useEffect(() => {
    setValue('traviTableValue', selected);
  }, [selected]);

  useEffect(() => {
    onResetTravi();
  }, [selectedIdx]);

  const changeAutocomplete = value => {
    setSelected(value);
  };

  const changeTravi = () => {
    const tipologiaTraveTableValue = getValues('tipologiaTraveTableValue');

    const ids = selected.map(el => el.codice);

    const travi = [...traviFields];

    travi.map((x, index) => {
      if (ids?.includes(x?.codice)) {
        travi[index] = {
          ...x,
          tipologiaTrave: tipologiaTraveTableValue,
          ...(tipologiaTraveTableValue !== x.tipologiaTrave
            ? {
                ...resetObjectSchedaIspezione,
                schedaDifetti: populateSchedaDifetti(
                  'trave',
                  tipologiaTraveTableValue
                ).map(el => {
                  return {
                    ...el,
                    visto: false,
                    statoDifetto: '',
                    estensioneDifetto: '',
                    intensitaDifetto: '',
                    ps: false,
                    note: '',
                    media: [],
                  };
                }),
              }
            : null),
        };
      }
    });

    setValue(traviTable, travi);
    onResetTravi();
  };

  const onConfirmChangeTravi = () => {
    setOpenConfirmationDialog(false);
    changeTravi();
  };

  const onSubmitTravi = () => {
    const tipologiaTraveTableValue = getValues('tipologiaTraveTableValue');

    const ids = selected.map(el => el.codice);

    const travi = [...traviFields];

    const hasChangedTipologia = travi.some(el => {
      if (ids.includes(el?.codice)) {
        return (
          tipologiaTraveTableValue !== el.tipologiaTrave &&
          !isNullOrUndefinedOrEmptyString(el.tipologiaTrave)
        );
      }
    });

    if (hasChangedTipologia) {
      setOpenConfirmationDialog(true);
    } else {
      changeTravi();
    }
  };

  const onResetTravi = () => {
    setValue('traviTableValue', []);
    setValue('tipologiaTraveTableValue', '');
    setSelected([]);
  };

  return (
    <>
      <GridWrap container spacing={2} mt={2}>
        <InfoWrapper size={3} infoMessage={INFO.traviSelezionate.infoMessage}>
          <RHFTagAutocomplete
            multiple={true}
            id="tags-travi"
            name={'traviTableValue'}
            changeAutocomplete={value => {
              changeAutocomplete(value);
            }}
            labelName={'option.codice'}
            getOptionLabel={option => option.codice}
            opt={traviFields?.filter(
              el => !selected?.some(s => s?.id === el?.id)
            )}
            label="Travi selezionate"
          />
        </InfoWrapper>
        <GridWrap item xs={3}>
          <RHFSelect
            name="tipologiaTraveTableValue"
            label="Tipologia Trave"
            defaultValue={''}
            onChange={e => {
              setValue('tipologiaTraveTableValue', e.target.value);
            }}
            selectOptions={tipologiaTraveOptions}
          />
        </GridWrap>
        <GridWrap item xs={6} alignSelf="center">
          <FormSubmitButtons onSubmit={onSubmitTravi} onReset={onResetTravi} />
        </GridWrap>
      </GridWrap>
      <ChangeElementTypologyDialog
        open={openConfirmationDialog}
        onClose={() => setOpenConfirmationDialog(false)}
        onConfirm={onConfirmChangeTravi}
      />
    </>
  );
};
TraviForm.propTypes = {
  traviFields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      codice: PropTypes.string,
      tipologiaTrave: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  selected: PropTypes.array,
  setSelected: PropTypes.func,
  traviTable: PropTypes.string,
  selectedIdx: PropTypes.number,
};

export default TraviForm;
